// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-picker[data-v-79f610fc]{position:relative;width:100%;text-align:center}.file-picker-input[data-v-79f610fc]{position:absolute;z-index:-1;visibility:hidden}", ""]);
// Exports
module.exports = exports;
